<template>
  <div :qaid="`nav-card-${card.uid}`" class="nav-card">
    <img v-if="card.img" :src="card.img" class="nav-card__img" />
    <div v-if="card.text" class="nav-card__text" v-html="card.text" />
    <a v-if="card.action" class="nav-card__link" :href="card.action.url" :target="card.action.target">
      <span class="nav-card__link-text" v-html="card.action.text" />
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" fill="currentColor" />
      </svg>
    </a>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'NavCard',
  computed: {
    ...mapState('navigation', ['activeTab', 'currentOverlay']),
    card() {
      return this.currentOverlay?.tabs.find((tab) => tab.uid === this.activeTab)?.card;
    },
  },
};
</script>

<style scoped lang="scss">
.nav-card {
  &__img {
    @apply mb-2;
    width: 100%;
  }

  &__text {
    @apply text-gray-30;
    @apply text-sm;
    @apply leading-normal;
    @apply font-medium;
  }

  &__link {
    @apply mt-2;
    @apply text-gray-30;
    @apply hover:text-white;
    display: flex;
    align-items: center;

    &-text {
      @apply mr-1;
      @apply text-sm;
      @apply leading-normal;
      @apply font-medium;
    }
  }
}
</style>
